import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/pages/NotFound'
import Index from '@/pages/Index'

// 履约供方
import peSupplierList from '@/pages/dsp/notice/PeSupplierList'
import performanceSupplierNoticeInfo from '@/pages/performanceSupplierNoticeInfo'

import sysYearList from '@/pages/dsp/notice/SysYearList'

//import Invite from '@/pages/demo/InviteBid'
//import Demo from '@/pages/demo/Demo'
//import SupplierInfo from '@/pages/demo/SupplierInfo'
//import BasicInfo from '@/pages/demo/sp-info/BasicInfo'
//import OtherInfo from '@/pages/demo/sp-info/OtherInfo'
//import ContactInfo from '@/pages/demo/sp-info/ContactInfo'
import Register from '@/pages/dsp/register/Register'
import Login from '@/pages/dsp/login/Login'
import AccountInfo from '@/pages/dsp/register/Account'
import CompanyInfo from '@/pages/dsp/register/Company'
import Supplier from '@/pages/dsp/supplier/Supplier'
import SBasic from '@/pages/dsp/supplier/Basic'
import SOther from '@/pages/dsp/supplier/Other'
import SContact from '@/pages/dsp/supplier/Contact'
import SService from '@/pages/dsp/supplier/Service'
import SPSS from '@/pages/dsp/supplier/Spss'
import SManager from '@/pages/dsp/supplier/Manager'
import SGysfj from '@/pages/dsp/supplier/Gysfj'
import SAudit from '@/pages/dsp/supplier/Audit'
import SChangeHistory from '@/pages/dsp/supplier/ChangeHistory'
import SPass from '@/pages/dsp/supplier/Password'
import SBind from '@/pages/dsp/supplier/Bind'
import Changename from '@/pages/dsp/supplier/Changename'
import BankInfo from '@/pages/dsp/supplier/BankInfo'
import Agreement from '@/pages/dsp/supplier/Agreement'
////
import Home from '@/pages/dsp/Home'//登录后首页
import TodoList from '@/pages/dsp/home/TodoList'
import MsgList from '@/pages/dsp/home/MsgList'
import MsgDetail from '@/pages/dsp/home/MsgDetail'
import CustomerMsgDetail from '@/pages/dsp/home/customerDetail'
import Forget from '@/pages/dsp/home/Forget'
import Help from '@/pages/dsp/help/Help'//帮助
import Download from '@/pages/dsp/help/Download'//帮助
import NoticeList from '@/pages/dsp/notice/NoticeList'//公告
import NoticeInfo from '@/pages/dsp/notice/NoticeInfo'//公告详情
import CarouseDetail from '@/pages/dsp/carouse/CarouseDetail'//轮播图详情
//
// 招标
import InviteList from '@/pages/dsp/invite/InviteList'
import InviteInfo from '@/pages/dsp/invite/InviteInfo'
import InviteMngList from '@/pages/dsp/invite/InviteMngList'
import InviteMngInfo from '@/pages/dsp/invite/InviteMngInfo'
import IndependentBidInfo from '@/pages/dsp/invite/IndependentBidInfo'
// 第二次独立竞价
import IndependentInfoTwo from '@/pages/dsp/invite/IndependentInfoTwo'
import InviteBid from '@/pages/dsp/invite/InviteBid'
import InviteNego from '@/pages/dsp/invite/InviteNego'
import InviteNegoDetail from '@/pages/dsp/invite/InviteNegoDetail'
import NewBid from '@/pages/dsp/invite/NewBid'
// 信息互通
import MsgexList from '@/pages/dsp/msgex/messageTabs'
import newMessageTabs from '@/pages/dsp/msgex/newMessageTabs'
// 合同业务
import ContractList from '@/pages/dsp/contract/List'
import ContractSheet from '@/pages/dsp/contract/Sheet'
import ContractDetail00 from '@/pages/dsp/contract/vDetail00'
import ContractDetail01 from '@/pages/dsp/contract/vDetail01'
import ContractDetail02 from '@/pages/dsp/contract/vDetail02'
import ContractDetail03 from '@/pages/dsp/contract/vDetail03'
import ContractDetail04 from '@/pages/dsp/contract/vDetail04'
import ContractDetail05 from '@/pages/dsp/contract/vDetail05'
import ContractDetail07 from '@/pages/dsp/contract/vDetail07'
import ContractDetail08 from '@/pages/dsp/contract/vDetail08'
import ContractDetail09 from '@/pages/dsp/contract/vDetail09'
import ContractDetail10 from '@/pages/dsp/contract/vDetail10'
import ContractDetail11 from '@/pages/dsp/contract/vDetail11'
import ContractDetail12 from '@/pages/dsp/contract/vDetail12'
import ContractDetail13 from '@/pages/dsp/contract/vDetail13'
import ContractDetail14 from '@/pages/dsp/contract/vDetail14'
import ContractDetail15 from '@/pages/dsp/contract/vDetail15'

//// 中标
import WinList from '@/pages/dsp/win/List'
import WinDetail from '@/pages/dsp/win/Detail'
//// 投诉、举报通道
import TunlList from '@/pages/dsp/tunl/TunlList'
import TunlInfo from '@/pages/dsp/tunl/TunlInfo'
import TunlListRep from '@/pages/dsp/tunl/TunlListRep'
import TunlInfoRep from '@/pages/dsp/tunl/TunlInfoRep'
// 履约评估
import PerformanceEvaMain from '@/pages/dsp/pfeva/PerformanceEvaMain'

// 缺陷指引
import bugguideList from '@/pages/dsp/cr9/bugguide/bugguideList'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },{
            path: '/peSupplierList',
            name: 'peSupplierList',
            component: peSupplierList
        },{
            path: '/sysYearList',
            name: 'sysYearList',
            component: sysYearList
        },
        {
            path: '/performanceSupplierNoticeInfo/:id',
            name: 'performanceSupplierNoticeInfo',
            component: performanceSupplierNoticeInfo
        },
        {
            path: '/home',
            name: 'Home',
            component: Home
        },
        {
            path: '/todoList/:type?',
            name: 'TodoList',
            component: TodoList
        },
        {
            path: '/msgList/:type?',
            name: 'MsgList',
            component: MsgList
        },
        {
            path: '/msgDetail/:id',
            name: 'MsgDetail',
            component: MsgDetail
        },
        {
            path: '/CustomerMsgDetail/:url',
            name: 'CustomerMsgDetail',
            component: CustomerMsgDetail
        },

        {
            path: '/forget',
            name: 'Forget',
            component: Forget
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/inviteBid/:fid/:pid/:type/:urlFid/:buttonFlag?',
            name: 'InviteBid',
            component: InviteBid
        },
        {
            path: '/inviteList',
            name: 'InviteList',
            component: InviteList
        },
        {
            path: '/inviteInfo/:fid',
            name: 'InviteInfo',
            component: InviteInfo
        },
        {
            path: '/inviteMngList',
            name: 'InviteMngList',
            component: InviteMngList
        },
        {
            path: '/inviteMngInfo/:fid',
            name: 'InviteMngInfo',
            component: InviteMngInfo
        },
        {
            path: '/IndependentBidInfo/:fid',
            name: 'IndependentBidInfo',
            component: IndependentBidInfo
        },
        {
            path: '/IndependentInfoTwo/:fid',
            name: 'IndependentInfoTwo',
            component: IndependentInfoTwo
        },
        {
            path: '/inviteNego/:id/:name',
            name: 'InviteNego',
            component: InviteNego
        },
        {
            path: '/inviteNegoDetail/:fid/:id/:name',
            name: 'InviteNegoDetail',
            component: InviteNegoDetail
        },
        {
            path: '/newBid/:times/:id',
            name: 'NewBid',
            component: NewBid
        },
        {
            path: '/msgexList',
            name: 'MsgexList',
            component: MsgexList
        },
        {
            path: '/newMsgList',
            name: 'newMsgList',
            component: newMessageTabs
        },
        {
            path: '/contractList',
            name: 'ContractList',
            component: ContractList
        },{
            path: '/contractSheet/:id',
            name: 'ContractSheet',
            component: ContractSheet
        },{
            path: '/contractDetail00/:type/:id/:name',  // type:0 [发起]带billId;  type:1 [查看]带msgId(接口也能获到billId); 第三个参数始终为合同名称转义;
            name: 'ContractDetail00',
            component: ContractDetail00
        },{
            path: '/contractDetail01/:type/:id/:name',
            name: 'ContractDetail01',
            component: ContractDetail01
        },{
            path: '/contractDetail02/:type/:id/:name',
            name: 'ContractDetail02',
            component: ContractDetail02
        },{
            path: '/contractDetail03/:type/:id/:name',
            name: 'ContractDetail03',
            component: ContractDetail03
        },{
            path: '/contractDetail04/:type/:id/:name',
            name: 'ContractDetail04',
            component: ContractDetail04
        },{
            path: '/contractDetail05/:type/:id/:conid/:name',  // type: 0 设计 1 工程
            name: 'ContractDetail05',
            component: ContractDetail05
        },{
            path: '/contractDetail07/:type/:id/:name',
            name: 'ContractDetail07',
            component: ContractDetail07
        },{
            path: '/contractDetail08/:type/:id/:name',
            name: 'ContractDetail08',
            component: ContractDetail08
        },{
            path: '/contractDetail09/:type/:id/:name',
            name: 'ContractDetail09',
            component: ContractDetail09
        },{
            path: '/contractDetail10/:type/:id/:name/:from/:lastApproveId',
            name: 'ContractDetail10',
            component: ContractDetail10
        },{
            path: '/contractDetail11/:type/:id/:name',
            name: 'ContractDetail11',
            component: ContractDetail11
        },{
            path: '/contractDetail12/:type/:id/:name/:nowType',
            name: 'ContractDetail12',
            component: ContractDetail12
        },{
            path: '/contractDetail13/:type/:id/:name',
            name: 'ContractDetail13',
            component: ContractDetail13
        },{
            path: '/contractDetail14/:id/:name?/:billId?',
            name: 'ContractDetail14',
            component: ContractDetail14
        },
        {
            path: '/contractDetail15/:type/:id/:name/:from/:lastApproveId',
            name: 'ContractDetail15',
            component: ContractDetail15
        },
        {
            path: '/winList',
            name: 'WinList',
            component: WinList
        },{
            path: '/winDetail/:fid',
            name: 'WinDetail',
            component: WinDetail
        },
        //{
        //    path: '/demo',
        //    name: 'Demo',
        //    component: Demo
        //},
        // {
        //    path: '/info',
        //    component: SupplierInfo,
        //    children: [
        //        // an empty path will be treated as the default, e.g.
        //        // components rendered at /parent: Root -> Parent -> Default
        //        { path: '', name: 'basic-info', component: BasicInfo },
        //
        //        // components rendered at /parent/foo: Root -> Parent -> Foo
        //        { path: 'other', component: OtherInfo },
        //
        //        // components rendered at /parent/bar: Root -> Parent -> Bar
        //        { path: 'contact', component: ContactInfo }
        //    ]
        //},
        {
            path: '/register',
            component: Register,
            children: [
                // an empty path will be treated as the default, e.g.
                // components rendered at /parent: Root -> Parent -> Default
                { path: '', name:'Register', component: AccountInfo },

                // components rendered at /parent/foo: Root -> Parent -> Foo
                { path: 'next', name:'RegisterNext', component: CompanyInfo }
            ]
        },
         {
            path: '/supplier',
            component: Supplier,
            children: [
                { path: '', name: 'Supplier', component: SBasic },
                { path: 'other', name:'Other', component: SOther },
                { path: 'contact', name:'Contact', component: SContact },
                { path: 'service', name:'Service', component: SService },
                { path: 'spss', name:'Spss', component: SPSS },
                { path: 'manager', name:'Manager', component: SManager },
                { path: 'gysfj', name:'Gysfj', component: SGysfj },
                { path: 'audit', name: 'Audit', component: SAudit },
                { path: 'changeHistory', name: 'ChangeHistory', component: SChangeHistory },
                { path: 'pass', component: SPass },
                { path: 'bind', component: SBind },
                { path: 'changename', component: Changename },
                { path: 'bankinfo', name:'BankInfo', component: BankInfo },
                { path: 'agreement', name:'Agreement', component: Agreement }
            ]
        },
        {
            path: '/help',
            name: 'Help',
            component: Help
        },
        {
            path: '/download',
            name: 'Download',
            component: Download
        },
        {
            path: '/carouse',
            name: 'CarouseDetail/:fid',
            component: CarouseDetail
        },
        {
            path: '/notice',
            name: 'NoticeList',
            component: NoticeList
        },
        {
            path: '/noticeInfo/:id',
            name: 'NoticeInfo',
            component: NoticeInfo
        },
        {
            path: '/tunlList',
            name: 'TunlList',
            component: TunlList
        },
        {
            path: '/tunlInfo/:id',
            name: 'TunlInfo',
            component: TunlInfo
        },
        {
            path: '/tunlListRep',
            name: 'TunlListRep',
            component: TunlListRep
        },
        {
            path: '/tunlInfoRep/:id',
            name: 'TunlInfoRep',
            component: TunlInfoRep
        },
        {
            path: '/not-found',
            name: 'not-found',
            component: NotFound
        },
        {
            path: '*',
            redirect: '/not-found'
        },
        { // 履约评估
            path: '/performanceEvaMain',
            name: 'PerformanceEvaMain',
            component: PerformanceEvaMain
        },{
            path: '/bugguideList',
            name: 'bugguideList',
            component: bugguideList
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js